import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { WorkForm } from './../forms'
import { Dashboard } from './../layouts'
import axios from './../plugins/axios'

const styles = theme => ({
    //
})

class WorkNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Төсөл',
            key: shortid.generate(),
            services: []
        }
    }

    componentDidMount = () => {
        this.fetchServices()
    }

    fetchServices = async () => {
        try {
            const { data } = await axios.get('/services', {
                progress: true,
                params: {
                    rowsPerPage: -1,
                    sortBy: 'name',
                    sortOrder: 'asc'
                }
            })

            this.setState({
                key: shortid.generate(),
                services: data
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            key,
            title,
            services
        } = this.state
        return (
            <Dashboard title={title}>
                <WorkForm 
                    key={key}
                    services={services}
                    path="works"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(WorkNew)
